console.info("Request Trial v2.10");
if (typeof RequestTrial === "undefined") {
  var RequestTrial = {
    private: {
      role: {
        undo: function () {
          TDForm.helper.hideField("otherRole");
          TDForm.helper.hideField("user_name");
          TDForm.helper.hideField("user_age_category");
        },
        do_show_organization_type: function () {
          RequestTrial.private.role.undo();
          TDForm.helper.showField("user_name", true);
          TDForm.helper.showField("user_age_category", true);
        },
        do_show_other: function () {
          RequestTrial.private.role.undo();
          TDForm.helper.showField("otherRole", true);
        },
      },
      organization: {
        undo: function () {
          TDForm.helper.hideField("cho_zone");
          TDForm.helper.hideField("adult_child");
          TDForm.helper.hideField("company");

          RequestTrial.private.adultChild.undo();
        },
        do_public: function () {
          RequestTrial.private.organization.undo();
          TDForm.helper.showField("cho_zone", true);
          TDForm.helper.showField("adult_child", true);
        },
        do_private: function () {
          RequestTrial.private.organization.undo();
          TDForm.helper.showField("adult_child", true);
          TDForm.helper.showField("company", true);
        },
      },
      accessType: {
        undo: function () {
          TDForm.helper.hideField("stands");
          TDForm.helper.hideField("eye_gaze_support");
        },
        do_eyeGaze: function () {
          RequestTrial.private.accessType.undo();
          TDForm.helper.showField("stands", true);
          TDForm.helper.showField("eye_gaze_support", true);
          TDForm.helper.updateSelect(
            "devices",
            RequestTrial.data.devices.eyeGaze,
          );
        },
        do_touch: function () {
          RequestTrial.private.accessType.undo();
          TDForm.helper.showField("stands", true);
          TDForm.helper.updateSelect(
            "devices",
            RequestTrial.data.devices.touch,
          );
        },
      },
      device: {
        undo: function () {
          TDForm.helper.updateSelect("software", RequestTrial.data.software.other);
        },
        do_tdPilot: function () {
          TDForm.helper.updateSelect("software", RequestTrial.data.software.tdPilot);
        },
        do_tdI110: function () {
          TDForm.helper.updateSelect("software", RequestTrial.data.software.tdI110);
        },
        do_tdNavio: function () {
          TDForm.helper.updateSelect("software", RequestTrial.data.software.tdNavio);
        },
      },
      deliveryAddress: {
        undo: function () {
          TDForm.helper.hideField("delivery_address");
          TDForm.helper.hideField("delivery_contact_name");
          TDForm.helper.hideField("delivery_contact_email");
          TDForm.helper.hideField("delivery_contact_phone");
          TDForm.helper.hideField("delivery_additional_info");
        },
        do_yes: function () {
          RequestTrial.private.deliveryAddress.undo();
        },
        do_no: function () {
          RequestTrial.private.deliveryAddress.undo();
          TDForm.helper.showField("delivery_address", true);
          TDForm.helper.showField("delivery_contact_name", true);
          TDForm.helper.showField("delivery_contact_email", true);
          TDForm.helper.showField("delivery_contact_phone", true);
          TDForm.helper.showField("delivery_additional_info", true);
        },
      },
      getLeadDescription: function () {
        let ohterPhone = document.getElementById("other_phone").value;
        if (ohterPhone) {
          return "Other Phone: " + ohterPhone;
        } else {
          return "";
        }
      },
      getOpportunityDescription: function () {
        return TDForm.helper.getDescriptionFromIds();
      },
      getOpportunityValues: function () {
        let op = {
          Name: RequestTrial.private.getOpportunityName(),
          Stage: "Qualification",
          RecordTypeId: "012QD000002iyov",
          CloseDateDuration: 30,
          Interest: document.getElementById("interest").value,
          Devices: document.getElementById("devices").selectedOptions[0].value,
          Software:
            document.getElementById("software").selectedOptions[0].value,
          CurrencyIsoCode: "EUR",
          OpType: "Trial",
          UserName: document.getElementById("user_name").value,
          UserAgeCategory: document.getElementById("user_age_category").value,
          Stands: document.getElementById("stands").selectedOptions[0].value,
          TrialVoice:
            document.getElementById("trial_voice").selectedOptions[0].value,
          ConsultationProvided: document.querySelector(
            'input[name="consultation_provided"]:checked',
          )?.value,
          DeliveryAddress: RequestTrial.private.getDeliveryAddress(),
          TrialLanguage:document.getElementById("trial_language").value,
        };

        return JSON.stringify(op);
      },
      getOpportunityName: function () {
        let name = document.getElementById("first_name").value;
        name += " " + document.getElementById("last_name").value;
        return name;
      },
      getDeliveryAddress: function () {
        let isSameAsAddress =
          document.querySelector('[name="is_delivery_address_same"]:checked')
            ?.value === "No"
            ? false
            : true;
        if (isSameAsAddress) {
          let address = "";
          address += document.getElementById("first_name").value + " ";
          address += document.getElementById("last_name").value + ", ";
          address += document.getElementById("address").value + ", ";
          if(document.getElementById("state")){
            address += document.getElementById("state").value + ", ";
          }
          address += document.getElementById("phone").value;
          return address;
        } else {
          return document.getElementById("delivery_address").value;
        }
      },
    },
    data: {
      devices: {
        eyeGaze: [
          { value: "I-13", name: "TD I-13 (S)" },
          { value: "I-16", name: "TD I-16 (S)" },
          { value: "TD Pilot", name: "TD Pilot (S)" },
        ],
        touch: [
          { value: "I-110", name: "TD I-110 (S)" },
          { value: "TD Navio Mini", name: "TD Navio Mini" },
          { value: "TD Navio Midi", name: "TD Navio Midi (S)" },
          { value: "TD Navio Maxi", name: "TD Navio Maxi (S)" },
        ],
      },
      software: {
        tdPilot: [
          { value: "TD Snap - Core First", name: "TD Snap - Core First" },
          { value: "TD Snap Express", name: "TD Snap Express" },
          { value: "TD Motor Plan 30", name: "TD Motor Plan 30" },
          { value: "TD Motor Plan 40", name: "TD Motor Plan 40" },
          { value: "TD Motor Plan 66", name: "TD Motor Plan 66" },
          { value: "TD Motor Plan 99", name: "TD Motor Plan 99" },
          { value: "TD Snap - Aphasia", name: "TD Snap - Aphasia" },
          { value: "TD Snap - Text", name: "TD Snap - Text" },
          { value: "TD Talk", name: "TD Talk" },
        ],
        tdI110: [
          { value: "TD Snap - Core First", name: "TD Snap - Core First" },
          { value: "TD Snap Express", name: "TD Snap Express" },
          { value: "TD Motor Plan 30", name: "TD Motor Plan 30" },
          { value: "TD Motor Plan 40", name: "TD Motor Plan 40" },
          { value: "TD Motor Plan 66", name: "TD Motor Plan 66" },
          { value: "TD Motor Plan 99", name: "TD Motor Plan 99" },
          { value: "TD Snap - Aphasia", name: "TD Snap - Aphasia" },
          { value: "TD Snap - Text", name: "TD Snap - Text" },
          { value: "Communicator 5", name: "Communicator 5" },
        ],
        tdNavio: [
          { value: "TD Snap - Core First", name: "TD Snap - Core First" },
          { value: "TD Snap Express", name: "TD Snap Express" },
          { value: "TD Motor Plan 30", name: "TD Motor Plan 30" },
          { value: "TD Motor Plan 40", name: "TD Motor Plan 40" },
          { value: "TD Motor Plan 66", name: "TD Motor Plan 66" },
          { value: "TD Motor Plan 99", name: "TD Motor Plan 99" },
          { value: "TD Snap - Aphasia", name: "TD Snap - Aphasia" },
          { value: "TD Snap - Text", name: "TD Snap - Text" },
          { value: "TD Talk", name: "TD Talk" },
        ],
        other: [
          { value: "TD Snap - Core First", name: "TD Snap - Core First" },
          { value: "TD Snap Express", name: "TD Snap Express" },
          { value: "TD Motor Plan 30", name: "TD Motor Plan 30" },
          { value: "TD Motor Plan 40", name: "TD Motor Plan 40" },
          { value: "TD Motor Plan 66", name: "TD Motor Plan 66" },
          { value: "TD Motor Plan 99", name: "TD Motor Plan 99" },
          { value: "TD Snap - Aphasia", name: "TD Snap - Aphasia" },
          { value: "TD Snap - Text", name: "TD Snap - Text" },
          { value: "TD Talk", name: "TD Talk" },
          { value: "Communicator 5", name: "Communicator 5" },
        ]

      },
    },
    changeHandler: {
      role: function (select) {
        let selectedOption = select.value;
        switch (selectedOption) {
          case "AAC or AT Specialist":
            RequestTrial.private.role.do_show_organization_type();
            break;
          case "Occupational Therapy":
            RequestTrial.private.role.do_show_organization_type();
            break;
          case "Speech Language Pathology/Therapy":
            RequestTrial.private.role.do_show_organization_type();
            break;
          case "Other":
            RequestTrial.private.role.do_show_other();
            break;
          default:
            RequestTrial.private.role.undo();
        }
      },
      accessType: function (select) {
        let selectedOption = select.value;
        switch (selectedOption) {
          case "Eye Gaze":
            RequestTrial.private.accessType.do_eyeGaze();
            break;
          case "Touch/Switch":
            RequestTrial.private.accessType.do_touch();
            break;
          default:
            RequestTrial.private.accessType.undo();
        }
      },
      device: function (select) {
        let selectedOption = select.value;
        switch (selectedOption) {
          case "TD Pilot":
            RequestTrial.private.device.do_tdPilot();
            break;
          case "I-110":
            RequestTrial.private.device.do_tdI110();
            break;
          case "TD Navio Mini":
          case "TD Navio Midi":
          case "TD Navio Maxi":
            RequestTrial.private.device.do_tdNavio();
            break;
          default:
            RequestTrial.private.device.undo();
        }
      },
      deliveryAddress: function (select) {
        let selectedOption = select.value;
        switch (selectedOption) {
          case "Yes":
            RequestTrial.private.deliveryAddress.do_yes();
            break;
          case "No":
            RequestTrial.private.deliveryAddress.do_no();
            break;
          default:
            RequestTrial.private.deliveryAddress.undo();
        }
      }
    },
    doSubmit: function (e) {
      const submitBtn = e.target.querySelector(
        'button[type="submit"], input[type="submit"]',
      );
      document.getElementById("op_values").value =
        RequestTrial.private.getOpportunityValues();
      document.getElementById("op_description").value =
        RequestTrial.private.getOpportunityDescription();
      document.getElementById("description").value =
        RequestTrial.private.getLeadDescriptionFromIds();

      if (submitBtn) submitBtn.disabled = true;
      return true;
    },
  };
}
